// TODO: implement it yourself
import { FrontendApi, Configuration } from '@ory/client';
import { Preferences } from '@capacitor/preferences';

const origin = import.meta.env.VITE_API_HOST;

const ory = new FrontendApi(
  new Configuration({
    basePath: `${origin}/auth-api`,
    baseOptions: { withCredentials: Boolean(import.meta.env.VITE_WITH_CREDENTIALS) },
  }),
);

const isNative = ['android', 'android_production'].includes(import.meta.env.MODE);

let logout: () => Promise<void>;

if (['android', 'android_production'].includes(import.meta.env.MODE)) {
  logout = async () => {
    const { value } = await Preferences.get({ key: 'hydrogen_session' });
    await ory.performNativeLogout!({
      performNativeLogoutBody: {
        session_token: value!,
      },
    });

    await Preferences.remove({ key: 'hydrogen_session' });
  };
} else {
  logout = async () => {
    const { data: flow } = await ory.createBrowserLogoutFlow!();

    await ory.updateLogoutFlow!({
      token: flow.logout_token,
    });
  };
}

export { logout, isNative };

export default ory;
